import React, { useState } from "react";
import AutoComplete from "../Autocomplete/index";
import css from "./Form.module.css";
import cn from "classnames";
import { SERVER_URL } from "../../config";

const Form = ({ formSubmission }) => {
  const [firstName, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [department, setDepartment] = useState("");
  const [subject, setSubject] = useState("");
  const [password, setPassword] = useState("");
  const [employeeNumber, setEmployeeNumber] = useState("");
  const [regMg, setRegMg] = useState("");

  const handleFirstNameChange = e => {
    setFirstName(e.target.value);
    console.log(e.target.value);
  };

  const handleSurnameChange = e => {
    setSurname(e.target.value);
  };

  const handleEmailChange = e => {
    setEmail(e.target.value);
  };

  const handleEmployeeNumberChange = e => {
    setEmployeeNumber(e.target.value);
  };

  const handleDepartment = e => {
    setDepartment(e.target.value);
  };

  const handlePassword = e => {
    setPassword(e.target.value);
  };

  const handleAutoComplete = value => {
    setSubject(value);
  };

  const onFormSubmit = e => {
    e.preventDefault();
    formSubmission(
      firstName,
      surname,
      email,
      department,
      password,
      employeeNumber
    );
  };

  async function postNewUser(event) {
    event.preventDefault();
    // submitLogin(email, password);

    //    function onSubmit(event) {
    //   event.preventDefault();
    //   submitLogin(email, password);
    // }

    const res = await fetch(`${SERVER_URL}/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      },
      body: JSON.stringify({
        firstName,
        surname,
        email,
        department,
        password,
        employeeNumber
      })
    });

    const data = await res.json();
    console.log("this is the register user response" + data.payload);
    setFirstName("");
    setSurname("");
    setEmail("");
    setPassword("");
    setDepartment("");
    setEmployeeNumber("");
    console.log(event);
    setRegMg(data.payload);
    console.log(data);

    //ALERT MESSAGE ADDED TO CONFIRM USER REGISTRATION
    if (data.payload) {
      setRegMg(true);
      alert("Your user has been registered correctly");
    }
  }

  return (
    <div className={css.formContainer}>
      <h1 className={css.header}> Register New User </h1>
      <form className={css.formID} onSubmit={onFormSubmit}>
        <div className={cn(css.input, "ui input")}>
          <input
            name="name"
            placeholder="First name"
            value={firstName}
            onChange={handleFirstNameChange}
          />
        </div>
        <div className={cn(css.input, "ui input")}>
          <input
            name="surname"
            placeholder="Surname"
            value={surname}
            onChange={handleSurnameChange}
          />
        </div>

        <div className={cn(css.input, "ui input")}>
          <input
            name="email"
            placeholder="Email"
            value={email}
            onChange={handleEmailChange}
          />
        </div>

        <div className={cn(css.input, "ui input")}>
          <p> Enter Your Unique Employee Number:</p>
          <input
            name="employeeNumber"
            placeholder="EmployeeNumber"
            value={employeeNumber}
            onChange={handleEmployeeNumberChange}
          />
        </div>

        <div className={cn(css.input, "ui input")}>
          <p> Your Department:</p>
          <input
            name="department"
            placeholder="Department"
            value={department}
            onChange={handleDepartment}
          />
        </div>

        <div className={cn(css.input, "ui input")}>
          <input
            name="password"
            placeholder="Password"
            value={password}
            onChange={handlePassword}
          />
        </div>
        <div>
          <button onClick={postNewUser} className={css.myButton}>
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default Form;
